// import { useState, useEffect } from "react";
// import dayjs from "dayjs";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { TextField } from "@mui/material";
// import { getPlanDates } from "api/dietPlan";

// function MuiDatePickerInput({ setDate, fetchDietPlan }) {
//   const [open, setOpen] = useState(false);
//   const [availableDates, setAvailableDates] = useState([]);

//   useEffect(() => {
//     const fetchAvailableDates = async () => {
//       try {
//         const response = await getPlanDates();
//         setAvailableDates(response);
//       } catch (error) {
//         console.error("Error fetching available dates:", error);
//       }
//     };
    
//     fetchAvailableDates();
//   }, []);

//   const shouldDisableDate = (date) => {
//     if (!availableDates.length) return true; 
    
//     const dateString = dayjs(date).format('YYYY-MM-DD');
//     return !availableDates.includes(dateString);
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <DatePicker
//         open={open}
//         onOpen={() => setOpen(true)}
//         onClose={() => setOpen(false)}
//         // value={date}
//         onChange={(newDate) => {
//           // setDate(newDate);
//           fetchDietPlan(newDate);
//         }}
//         shouldDisableDate={shouldDisableDate}
//         renderInput={(params) => (
//           <TextField
//             {...params}
//             onClick={() => setOpen(true)}
//             sx={{
//               "& .MuiInputBase-root": {
//                 cursor: "pointer",
//               },
//               "& .MuiInputBase-input": {
//                 cursor: "pointer",
//               },
//             }}
//           />
//         )}
//         componentsProps={{
//           actionBar: {
//             actions: ["today", "cancel", "accept"],
//           },
//         }}
//       />
//     </LocalizationProvider>
//   );
// }

// export default MuiDatePickerInput;


import { useState, useEffect } from "react";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { getPlanDates } from "api/dietPlan";

function MuiDatePickerInput({ setDate, fetchDietPlan }) {
  const [open, setOpen] = useState(false);
  const [availableDates, setAvailableDates] = useState([]);

  useEffect(() => {
    const fetchAvailableDates = async () => {
      try {
        const response = await getPlanDates();
        setAvailableDates(response);
      } catch (error) {
        console.error("Error fetching available dates:", error);
      }
    };
    fetchAvailableDates();
  }, []);

  const shouldDisableDate = (date) => {
    if (!availableDates.length) return true;
    const dateString = dayjs(date).format('YYYY-MM-DD');
    return !availableDates.includes(dateString);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        // 1. Setting the display and placeholder format
        format="DD/MM/YYYY" 
        label="DD/MM/YYYY"
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        onChange={(newDate) => {
          fetchDietPlan(newDate);
        }}
        shouldDisableDate={shouldDisableDate}
        // 2. Handling the click and styling via slots
        slotProps={{
          textField: {
            onClick: () => setOpen(true),
            placeholder: "DD/MM/YYYY", // Explicit placeholder
            sx: {
              "& .MuiInputBase-root": { cursor: "pointer" },
              "& .MuiInputBase-input": { cursor: "pointer" },
            },
          },
          actionBar: {
            actions: ["today", "cancel", "accept"],
          },
        }}
      />
    </LocalizationProvider>
  );
}

export default MuiDatePickerInput;